import { SPRest } from "../rest.js";
import { NavigationService } from "./types.js";
import "./web.js";
export { Navigation, NavigationNode, NavigationNodes, NavigationService, } from "./types.js";
Reflect.defineProperty(SPRest.prototype, "navigation", {
    configurable: true,
    enumerable: true,
    get: function () {
        return this.childConfigHook(function (_a) {
            var options = _a.options, baseUrl = _a.baseUrl, runtime = _a.runtime;
            return NavigationService(baseUrl).configure(options).setRuntime(runtime);
        });
    },
});
//# sourceMappingURL=index.js.map